import { render } from "./MealReservation.vue?vue&type=template&id=7925d59c&scoped=true"
import script from "./MealReservation.vue?vue&type=script&lang=js"
export * from "./MealReservation.vue?vue&type=script&lang=js"

import "./MealReservation.vue?vue&type=style&index=0&id=7925d59c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7925d59c"]])

export default __exports__